import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const ONBOARDING_SUBMIT_CONTRACT_GENERATION_STEP = gql`
    mutation OnboardingSubmitContractGenerationStep($candidateUuid: ID!) {
        onboardingSubmitContractGenerationStep(candidateUuid: $candidateUuid) {
            uuid
            step
        }
    }
`;

const useOnboardingSubmitContractGenerationStep = () => {
    const [mutate, { loading, error }] = useMutation(ONBOARDING_SUBMIT_CONTRACT_GENERATION_STEP);

    const submitContractGenerationStep = async (candidateUuid) => {
        return mutate({
            variables: { candidateUuid },
        });
    };

    return {
        submitContractGenerationStep,
        loading,
        error,
    };
};

export default useOnboardingSubmitContractGenerationStep;
